import React from 'react';
import { Link } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';

interface BusinessPlanHubHeaderProps {
  plansCount: number;
  ideasCount: number;
  showNewPlanButton?: boolean;
}

const BusinessPlanHubHeader: React.FC<BusinessPlanHubHeaderProps> = ({
  plansCount,
  ideasCount,
  showNewPlanButton = true,
}) => {
  return (
    <div className="rounded-2xl bg-white p-6 shadow-sm ring-1 ring-gray-100">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Business Plan Generator</h1>
          <p className="mt-1 text-sm text-gray-600">
            Create investor-ready business plans with AI assistance
          </p>
        </div>
        
        <div className="flex items-center gap-3">
          {/* Stats */}
          <div className="hidden sm:flex items-center gap-4 mr-4">
            <div className="text-center">
              <div className="text-2xl font-bold text-blue-600">{plansCount}</div>
              <div className="text-xs text-gray-500">Plans</div>
            </div>
            <div className="h-10 w-px bg-gray-200"></div>
            <div className="text-center">
              <div className="text-2xl font-bold text-gray-600">{ideasCount}</div>
              <div className="text-xs text-gray-500">Ideas</div>
            </div>
          </div>

          {showNewPlanButton ? (
            <>
              <Link
                to="/business-plan/new"
                data-tooltip-id="bp-new-plan"
                data-tooltip-content="Start a new business plan (choose an idea or template)"
                className="inline-flex items-center gap-2 rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
              >
                <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                </svg>
                <span>New Plan</span>
              </Link>
              <Tooltip id="bp-new-plan" place="bottom" />
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default BusinessPlanHubHeader;
